import React from "react";
// ANT DESIGN COMPONENTS
import { Select } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
import { OpcMappingType } from "../../../interfaces/AdapterCdoOpc.interface";

export default function FormSelectOpcMappingType({
  inputValue,
  inputOnChange,
  disabledInput,
}: {
  inputValue: string;
  inputOnChange: (newValue: OpcMappingType) => void;
  disabledInput: boolean;
}) {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const { Option } = Select;
  const [t] = useTranslation("global");
  const OPTIONS = ["opc cmd to msg", "msg to opc cmd", "opc cmd to sequence"];

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */

  // ************************************************ */
  // USE EFFECT ************************************* */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          <span className="generalStyles__inputFlexRequired">*</span>
          <span>{t("general.mappingType")}</span>
        </div>
        <div className="generalStyles__width100">
          <Select
            className="generalStyles__width100"
            size="small"
            onChange={(e: any) => {
              inputOnChange(e);
            }}
            value={inputValue}
            disabled={disabledInput}
          >
            {OPTIONS.map((item: string) => (
              <Option key={item} value={item}>
                {item}
              </Option>
            ))}
          </Select>
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
